import { type AxiosInstance } from 'axios'

interface ChangePasswordData {
  password1: string
  password2: string
}

export default (axios: AxiosInstance) => ({
  changePassword(data: ChangePasswordData) {
    return axios.post('/v1/profile/change-password/', data)
  },
})
